export default __webpack_public_path__ + "static/media/W51Kitchen.72f9faca.jpg";